import { BoxProps } from '@mui/material'
import { useUserEvents } from '@xylabs/sdk-coin-react'
import React from 'react'

import AccountSuccessBox from './AccountSuccessBox'

interface SuccessBoxProps extends BoxProps {
  email: string
}

const SuccessBox: React.FC<SuccessBoxProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { email, title = 'Success!', ...rootProps } = props

  const userEvents = useUserEvents()

  const onDownloadClick = () => {
    userEvents.installCompleted()
    return false
  }

  return <AccountSuccessBox title={title} onDownloadClick={onDownloadClick} {...rootProps} />
}

export default SuccessBox
